import React from "react";
import PropTypes from "prop-types";

const BodyData = ({ data }) => {
  return (
    <div className="body-data__container">
      {data.map((item) => {
        const { label, value } = item;
        return <BodyDataItem key={label} label={label} value={value} />;
      })}
    </div>
  );
};

BodyData.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const BodyDataItem = ({ label, value }) => {
  return (
    <div className="body-data__item-container">
      <div className="body-data__item-label">{label}</div>
      <div className="body-data__item-value">{value}</div>
    </div>
  );
};

BodyDataItem.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default BodyData;
